import React from 'react'

const AuthorizedLink = ({ authorization, external, href, children }) =>
  !authorization ? null :
    <li>
      <a target={external ? '_blank' : '_self'} rel='noopener noreferrer' href={href}>
        {children}
      </a>
    </li>

export default AuthorizedLink
